import { App, Plugin } from "vue";
import PrimeVue from "primevue/config";
import createPreset from "./theme";
import useTheme from "@/Hook/useTheme";

interface PluginOptions {
    globalComponent?: boolean;
    props: {
        initialPage: {
            props: {
                site: any;
            };
        };
    };
}

const AppSetup: Plugin = {
    install(app: App, options?: PluginOptions) {
        const { defineTheme } = useTheme(options?.props?.initialPage.props);
        app.use(PrimeVue, {
            theme: {
                preset: createPreset(defineTheme()),
                options: {
                    darkModeSelector: 'app'
                }
            },

        });
    },
};

export default AppSetup;
